class SchedulerHelper {
  constructor(_options) {
    this.options = _options;
    this.playIndex = 0;
    this.targetEle = this.options.targetId ? document.querySelector('#' + this.options.targetId) : null;
    this.scheduleData = this.options.scheduleData;
    this.timeoutId = -1;
  }

  /**
   * 스케줄 재생 시작
   */
  startSchedule() {
    // console.log(this.options.tag + ' startSchedule() : ', this.options);

    if (this.targetEle === null) {
      // console.error(this.options.tag + ' Empty element');
      return;
    } else if (!this.scheduleData || this.scheduleData.length <= 0) {
      // console.error(this.options.tag + ' Empty schedule data');
      return;
    }

    this.targetEle.style.zIndex = 5;

    this.playIndex = 0;

    this.playNext();
  }

  /**
   * 스케줄 재생 중단
   */
  stopSchedule() {
    // console.log(this.options.tag + ' stopSchedule() : ', this.options);

    this.targetEle.style.zIndex = 0;

    if (this.timeoutId >= 0) {
      clearTimeout(this.timeoutId);
      this.timeoutId = -1;
    }

    // 재생 중인 비디오 태그 찾아서 중지 및 스케줄 재생 Element 삭제
    let childElements = this.targetEle.getElementsByClassName('scheduleComp');
    if (childElements && childElements.length > 0) {
      for (let i = 0; i < childElements.length; i++) {
        if (childElements[i].tagName === 'VIDEO') {
          childElements[i].pause();
        }

        childElements[i].remove();
      }
    }
  }

  /**
   * 스케줄 뒤로 보내기
   */
  dimmedSchedule() {
    this.targetEle.style.zIndex = 0;
  }

  timeoutSchedule() {
    let timeout = setTimeout(() => {
      this.targetEle.style.zIndex = 5;
      clearTimeout(timeout);
    }, 30000);
  }

  /**
   * 다음 컨텐츠 재생
   */
  playNext() {
    var currentPage = window.location.pathname;
    // 페이지가 바뀌면 스케줄 재생 멈춤
    if (currentPage !== this.options.currentUrl) {
      this.stopSchedule();
      return;
    }

    if (this.playIndex >= this.scheduleData.length) {
      this.playIndex = 0;
    }

    let playData = this.scheduleData[this.playIndex++];
    if (!playData) {
      // console.error(this.options.tag + ' Empty next play data');
      return;
    }

    // console.log(this.options.tag + ' playNext() : ', playData);

    if (playData.DISP_KIND_CD === 'I') {
      // 이미지 재생
      this.playImage(playData);
    } else if (playData.DISP_KIND_CD === 'M') {
      // 동영상 재생
      this.playVideo(playData);
    } else if (playData.DISP_KIND_CD === 'T') {
      // 텍스트 재생은 스킵
      this.playNext();
    }
  }

  /**
   * 이미지 컨텐츠 재생
   */
  playImage(playData) {
    // console.log(this.options.tag + ' playImage() : ', playData);

    let imgTag = document.createElement('img');
    imgTag.src = playData.FILE_URL;
    imgTag.className = this.options.imageClass + ' scheduleComp';
    imgTag.style.zIndex = 5;

    if (this.options.tag === 'BRAND') {
      imgTag.style.height = '30vh';
    }

    this.targetEle.append(imgTag);

    let that = this;
    this.timeoutId = setTimeout(function () {
      imgTag.className += ' ended';
      that.playNext();
    }, playData.DISP_TIME * 1000);

    setTimeout(function () {
      that.removeEndedElements();
    }, 500);
  }

  /**
   * 비디오 컨텐츠 재생
   */
  playVideo(playData) {
    // console.log(this.options.tag + ' playVideo() : ', playData);

    let videoTag = document.createElement('video');
    videoTag.className = this.options.videoClass + ' scheduleComp';
    videoTag.src = playData.FILE_URL;
    videoTag.muted = true;
    videoTag.style.zIndex = 5;

    let that = this;

    videoTag.addEventListener('loadeddata', (event) => {
      videoTag.play();
      that.removeEndedElements();
    });

    videoTag.addEventListener('ended', (event) => {
      videoTag.className += ' ended';
      that.playNext();
    });

    this.targetEle.append(videoTag);
  }

  /**
   * 재생 종료 된 Elements 삭제
   */
  removeEndedElements() {
    let endedElements = this.targetEle.getElementsByClassName('ended');
    if (endedElements && endedElements.length > 0) {
      for (let i = 0; i < endedElements.length; i++) {
        endedElements[i].remove();
      }
    }
  }
}

/**
 * 스케줄러 객체 반환
 *
 * @param {} options : 컨텐츠 재생 할 Element 및 스케줄 데이터
 * @returns : 스케줄러 객체
 */
export default SchedulerHelper;
